import { useForm } from "react-hook-form";
import { CirclePlus } from "lucide-react";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import DateInput from "../../../components/UI/PageInput/DateInput";
import CustomInput from "../../../components/UI/PageInput/CustomInput";
import { nonNegativeNumberValidation } from "../../../validations/formValidations";
import MaterialTransportDialog from "../dialog/MaterialTransportDialog";

export const AddMaterialTransportForm = ({
  setup,
  sendData,
  successResponse,
  loading,
}) => {
  const {
    handleSubmit,
    setValue,
    control,
    watch,
    register,
    formState: { errors },
    reset,
  } = useForm();

  const { dateOfTransport } = watch();

  const onSubmit = (data) => {
    sendData(data, reset);
  };
  return (
    <>
      <div className="form-container">
        <CenteredHeading title="Add Material Transport" />
        <form
          onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        >
          <div className="form-border max-w-5xl mx-auto">
            <div className="flex gap-3 w-full">
              <div className="w-full">
                <SearchDropdown
                  name="material_id"
                  label="Material *"
                  keyName="name"
                  id="id"
                  options={setup.materials}
                  setValue={setValue}
                  control={control}
                  selectedVal={watch("material_id")}
                  error={errors.material_id}
                />
              </div>
              <div className="w-full">
                <CustomInput
                  type="number"
                  name="quantityRequired"
                  labelText="Required Quantity"
                  placeholder="Enter"
                  register={{
                    ...register("quantityRequired", {
                      ...nonNegativeNumberValidation,
                    }),
                  }}
                  error={errors.quantityRequired}
                />
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-full">
                <CustomInput
                  type="number"
                  name="quantityDispatchedFromFactory"
                  labelText="Quantity Dispatched from Factory"
                  placeholder="Enter"
                  register={{
                    ...register("quantityDispatchedFromFactory", {
                      ...nonNegativeNumberValidation,
                    }),
                  }}
                  error={errors.quantityDispatchedFromFactory}
                />
              </div>
              <div className="w-full">
                <CustomInput
                  type="number"
                  name="quantityReceivedAtSite"
                  labelText="Quantity Received at Site"
                  placeholder="Enter"
                  register={{
                    ...register("quantityReceivedAtSite", {
                      ...nonNegativeNumberValidation,
                    }),
                  }}
                  error={errors.quantityReceivedAtSite}
                />
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-full">
                <CustomInput
                  type="number"
                  name="quantityDispatchedFromSite"
                  labelText="Quantity Dispatched from Site"
                  placeholder="Enter"
                  register={{
                    ...register("quantityDispatchedFromSite", {
                      ...nonNegativeNumberValidation,
                    }),
                  }}
                  error={errors.quantityDispatchedFromSite}
                />
              </div>
              <div className="w-full">
                <CustomInput
                  type="number"
                  name="quantityReceivedAtFactory"
                  labelText="Quantity Received at Factory"
                  placeholder="Enter"
                  register={{
                    ...register("quantityReceivedAtFactory", {
                      ...nonNegativeNumberValidation,
                    }),
                  }}
                  error={errors.quantityReceivedAtFactory}
                />
              </div>
            </div>
            <div className="flex gap-3 w-full">
              <div className="w-full">
                <SearchDropdown
                  name="ft_id"
                  label="Field Technician *"
                  keyName="fullName"
                  id="id"
                  options={setup.fieldTechnicians}
                  setValue={setValue}
                  control={control}
                  selectedVal={watch("ft_id")}
                  error={errors.ft_id}
                  search={true}
                />
              </div>
              <div className="w-full">
                <DateInput
                  label="Transport Date *"
                  name={"dateOfTransport"}
                  value={dateOfTransport}
                  setValue={setValue}
                  register={{
                    ...register("dateOfTransport", {
                      required: "Please add transport date",
                    }),
                  }}
                  error={errors.dateOfTransport}
                  disableFutureDays={true}
                />
              </div>
            </div>
            <div className="flex gap-3 w-full">
              <div className="w-full">
                <CustomInput
                  type="text"
                  name="vehicleNumber"
                  labelText="Vehicle Number *"
                  placeholder="Enter"
                  register={{
                    ...register("vehicleNumber", {
                      required: "Please enter vehicle number",
                    }),
                  }}
                  error={errors.vehicleNumber}
                />
              </div>
              <div className="w-full">
                <CustomInput
                  type="text"
                  name="driverName"
                  labelText="Driver Name *"
                  placeholder="Enter"
                  register={{
                    ...register("driverName", {
                      required: "Please enter driver name",
                    }),
                  }}
                  error={errors.driverName}
                />
              </div>
            </div>
            <CustomInput
              type="text"
              name="remarks"
              labelText="Remark"
              placeholder="Ente"
              register={{
                ...register("remarks"),
              }}
            />
          </div>
          <div className="addBtn---wrap gap-2">
            <PrimaryButton
              btnText={!loading ? "Submit" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
            />
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
          </div>
        </form>
      </div>
      {successResponse && (
        <MaterialTransportDialog details={successResponse} successView={true} />
      )}
    </>
  );
};
